const STATUSES = ["active", "inactive", "suspended"] as const;

type StatusSelectProps = {
  value: string;
  onChange: (value: string) => void;
  includeAll?: boolean;
  allLabel?: string;
};

function StatusSelect({
  value,
  onChange,
  includeAll = false,
  allLabel = "All statuses",
}: StatusSelectProps) {
  return (
    <select
      value={value}
      onChange={(event) => onChange(event.target.value)}
      className="h-10 rounded-xl border border-slate-200 bg-white px-3 text-sm text-slate-700"
    >
      {includeAll && <option value="">{allLabel}</option>}
      {STATUSES.map((item) => (
        <option key={item} value={item}>
          {item}
        </option>
      ))}
    </select>
  );
}

export default StatusSelect;
